module.exports = __webpack_public_path__ + "static/gallery7-c9fcbb0a9ece65d2370752e800e8fbcb.jpg";